import { useState } from "react";
import { probe, customTarget } from "../../lib/servers";

export const CustomServerFields = ({ form, setForm }) => {
  const [check, setCheck] = useState(null);
  const run = async () => {
    setCheck({ state: "busy" });
    try { setCheck({ state: "ok", ms: await probe(customTarget(form.custom_server_url)) }); }
    catch (e) { setCheck({ state: "fail", msg: e.message }); }
  };
  return (
    <div className="space-y-2 border-l-2 border-[#007AFF] pl-3" data-testid="custom-server-fields">
      <input data-testid="custom-server-url-input" type="url" placeholder="https://speedtest.yourdomain.co.za/backend"
        value={form.custom_server_url || ""} onChange={(e) => { setForm({ ...form, custom_server_url: e.target.value }); setCheck(null); }} className="field w-full" />
      <input data-testid="custom-server-name-input" placeholder="Display name, e.g. Teraco JB1 (NAPAfrica)" maxLength={60}
        value={form.custom_server_name || ""} onChange={(e) => setForm({ ...form, custom_server_name: e.target.value })} className="field w-full" />
      <div className="flex items-center gap-3">
        <button type="button" data-testid="test-custom-server-button" onClick={run} disabled={!form.custom_server_url || check?.state === "busy"} className="btn-ghost text-xs disabled:opacity-40">
          {check?.state === "busy" ? "Testing…" : "Test connection"}
        </button>
        {check?.state === "ok" && <span className="text-[11px] text-[#32D74B]" data-testid="custom-server-ok">Reachable · {check.ms} ms</span>}
        {check?.state === "fail" && <span className="text-[11px] text-[#FF3B30]" data-testid="custom-server-fail">Not reachable ({check.msg}). Check the URL and that the server allows cross-origin (CORS) requests.</span>}
      </div>
      <p className="text-[10px] text-neutral-600">LibreSpeed-compatible server: the URL is the folder containing <code>empty.php</code> and <code>garbage.php</code>.</p>
    </div>
  );
};
